<template>
  <main class="bg-slate-50 py-12 sm:py-16">
    <article class="mx-auto max-w-4xl rounded-lg bg-white px-6 py-10 text-gray-700 shadow-sm sm:px-10">
      <h1 class="text-2xl font-bold tracking-tight text-gray-900 sm:text-4xl">
        Политика конфиденциальности и обработки персональных данных
      </h1>
      <p class="mt-4 text-sm text-gray-500">Редакция от 6 августа 2026 года</p>

      <section>
        <h2>1. Общие положения</h2>
        <p>
          Настоящая Политика определяет порядок сбора, обработки, хранения и защиты персональных данных
          пользователей сайта azia2012.kz (далее — «Сайт»).
        </p>
        <p>
          Оператор персональных данных — Товарищество с ограниченной ответственностью "Компания АЗиЯ 2012",
          БИН 120140014929 (далее — «Компания»).
        </p>
        <p>
          Компания обрабатывает персональные данные в соответствии с законодательством Республики Казахстан,
          в том числе Законом Республики Казахстан «О персональных данных и их защите».
        </p>
      </section>

      <section>
        <h2>2. Какие персональные данные обрабатываются</h2>
        <p>Компания может собирать и обрабатывать следующие сведения:</p>
        <ul>
          <li>фамилия, имя и отчество (ФИО);</li>
          <li>номер телефона;</li>
          <li>индивидуальный идентификационный номер (ИИН);</li>
          <li>наименование организации;</li>
          <li>должность.</li>
        </ul>
      </section>

      <section>
        <h2>3. Цели обработки персональных данных</h2>
        <p>Персональные данные обрабатываются для:</p>
        <ul>
          <li>приема и обработки обращений и заявок;</li>
          <li>заключения и исполнения договоров, оказания услуг и организации обучения;</li>
          <li>создания и обслуживания учетной записи пользователя;</li>
          <li>идентификации пользователя и связи с ним;</li>
          <li>исполнения требований законодательства Республики Казахстан;</li>
          <li>направления информационных и рекламных сообщений при наличии предусмотренного законом основания.</li>
        </ul>
      </section>

      <section>
        <h2>4. Основания и способы обработки</h2>
        <p>
          Обработка выполняется с согласия субъекта персональных данных, предоставленного способом, позволяющим
          подтвердить его получение, а также в иных случаях, предусмотренных законодательством Республики Казахстан.
        </p>
        <p>
          Компания может осуществлять сбор, запись, систематизацию, накопление, хранение, уточнение, использование,
          передачу в предусмотренных законом случаях, обезличивание, блокирование и уничтожение персональных данных
          с использованием средств автоматизации или без них.
        </p>
        <p>
          Срок обработки не превышает срока, необходимого для достижения заявленных целей, если иной срок не установлен
          законодательством или договором. После достижения целей данные уничтожаются или обезличиваются, если отсутствуют
          законные основания для их дальнейшего хранения.
        </p>
      </section>

      <section>
        <h2>5. Передача и защита персональных данных</h2>
        <p>
          Компания не распространяет персональные данные без согласия пользователя, кроме случаев, установленных
          законодательством Республики Казахстан. Доступ к данным может предоставляться работникам и привлеченным
          исполнителям только в объеме, необходимом для выполнения их обязанностей и оказания услуг Компании.
        </p>
        <p>
          Компания принимает необходимые организационные и технические меры для защиты персональных данных от
          неправомерного доступа, изменения, раскрытия, блокирования, копирования, распространения и уничтожения.
        </p>
      </section>

      <section>
        <h2>6. Информационные и рекламные рассылки</h2>
        <p>
          Компания имеет право направлять Пользователю уведомления о продуктах и услугах, специальных предложениях,
          акциях и различных событиях при наличии согласия Пользователя или иного предусмотренного законом основания.
        </p>
        <p>
          Пользователь может в любое время отказаться от получения таких сообщений, направив письмо на
          <a href="mailto:azia_2012@inbox.ru?subject=Отказ%20от%20уведомлений">azia_2012@inbox.ru</a>
          с темой «Отказ от уведомлений». После получения обращения Компания прекратит рассылку на указанные
          Пользователем контактные данные.
        </p>
      </section>

      <section>
        <h2>7. Права пользователя</h2>
        <p>Пользователь вправе:</p>
        <ul>
          <li>получать сведения об обработке своих персональных данных;</li>
          <li>требовать уточнения, блокирования или уничтожения данных при наличии законных оснований;</li>
          <li>отозвать согласие на сбор и обработку данных, если это не противоречит законодательству и не препятствует исполнению неисполненных обязательств;</li>
          <li>обжаловать действия или бездействие Компании в установленном законом порядке.</li>
        </ul>
        <p>
          Для реализации прав пользователь может обратиться по адресу
          <a href="mailto:azia_2012@inbox.ru">azia_2012@inbox.ru</a>.
          Компания вправе запросить сведения, необходимые для идентификации заявителя.
        </p>
      </section>

      <section>
        <h2>8. Изменение Политики</h2>
        <p>
          Компания вправе обновлять настоящую Политику. Новая редакция вступает в силу с момента ее размещения на Сайте,
          если иное не указано в новой редакции.
        </p>
      </section>

      <section>
        <h2>9. Реквизиты и контакты Компании</h2>
        <dl>
          <div>
            <dt>Юридическое наименование</dt>
            <dd>Товарищество с ограниченной ответственностью "Компания АЗиЯ 2012"</dd>
          </div>
          <div>
            <dt>БИН</dt>
            <dd>120140014929</dd>
          </div>
          <div>
            <dt>Юридический адрес</dt>
            <dd>ГОРОД АСТАНА, РАЙОН ЕСИЛЬ, ШОССЕ КОРГАЛЖЫН, д. 19, сектор А, оф. 200</dd>
          </div>
          <div>
            <dt>Телефоны</dt>
            <dd>
              <a href="tel:+77172793147">+7 (7172) 79 31 47</a>,
              <a href="tel:+77012448723">+7 (701) 244 87 23</a>
            </dd>
          </div>
          <div>
            <dt>Email</dt>
            <dd><a href="mailto:azia_2012@inbox.ru">azia_2012@inbox.ru</a></dd>
          </div>
        </dl>
      </section>
    </article>
  </main>
</template>

<style scoped>
section {
  margin-top: 2rem;
}

h2 {
  color: rgb(17 24 39);
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.75rem;
}

p,
ul,
dl {
  margin-top: 0.75rem;
  line-height: 1.75;
}

ul {
  list-style: disc;
  padding-left: 1.5rem;
}

a {
  color: rgb(37 99 235);
  text-decoration: underline;
  text-underline-offset: 2px;
}

dl > div {
  border-bottom: 1px solid rgb(229 231 235);
  padding: 0.75rem 0;
}

dt {
  color: rgb(55 65 81);
  font-weight: 600;
}

dd {
  margin-top: 0.25rem;
}
</style>
